import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/cn';

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold',
  {
    variants: {
      variant: {
        default: 'bg-primary-subtle text-primary',
        success: 'bg-accent-light text-accent',
        warning: 'bg-yellow-50 text-warning',
        error: 'bg-red-50 text-error',
        neutral: 'bg-gray-100 text-gray-600',
        info: 'bg-blue-50 text-info',
      },
      dot: { true: '', false: '' },
    },
    defaultVariants: { variant: 'default', dot: false },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, dot, children, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant, dot, className }))} {...props}>
      {dot && <span className="h-1.5 w-1.5 rounded-full bg-current" />}
      {children}
    </span>
  );
}

export { badgeVariants };
